import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../LayoutComponents/UseAuth";

const PrivateRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
